import React, { Fragment, useEffect } from 'react';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { ButtonToolbar, Button } from 'reactstrap';
import FormFields from './FormFields';
import validate from './validate';

const QuestionDatabaseForm = (props) => {
  const { t, backHandler, handleSubmit, change, dto, initialize } = props;

  const onDescriptionChange = (value) => {
    change('description', value);
  };

  useEffect(() => {
    initialize(dto);
  }, [dto]);

  const removeItemClickHandler = (evt, rowData) => {
    console.log('removeItemClickHandler -> rowData', rowData);
  };

  const answerUpdateHandler = (newAnswers) => {
    change('answers', newAnswers);
  };

  return (
    <Fragment>
      <form className="form" onSubmit={handleSubmit}>
        <FormFields
          onDescriptionChange={onDescriptionChange}
          removeItemClickHandler={removeItemClickHandler}
          answerUpdateHandler={answerUpdateHandler}
          dto={dto}
        />
        <ButtonToolbar className="form__button-toolbar">
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          <Button color="success" type="submit">
            {t('general.save')}
          </Button>
        </ButtonToolbar>
      </form>
    </Fragment>
  );
};

QuestionDatabaseForm.propTypes = {
  t: PropTypes.func.isRequired,
  backHandler: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  dto: PropTypes.shape(PropTypes.shape).isRequired,
};

export default reduxForm({
  form: 'QuestionDatabaseForm',
  validate,
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
})(withTranslation('common')(QuestionDatabaseForm));
